module.exports = __webpack_public_path__ + "static/media/zeren.2179709c.png";